import ROLE from "models/role";
import useCaminoStore from "./useCaminoStore";

export function useCurrentUserPermissions() {
  const currentUser = useCaminoStore((state) => state.currentUser);
  return currentUser?.permission || [];
}

export function useIsCurrentUserCompanyAdmin() {
  const permissions = useCurrentUserPermissions();
  return permissions.includes(ROLE.COMPANY_ADMIN);
}

export function useCanManageIntegrations() {
  const permissions = useCurrentUserPermissions();
  return (
    permissions.includes(ROLE.COMPANY_ADMIN) ||
    permissions.includes(ROLE.PEOPLE_TEAM) ||
    permissions.includes(ROLE.IT_ADMIN)
  );
}
